import { makeStyles } from 'tss-react/mui';
import { MediaFormatEnum } from '../../../modules/general-settings/enums/mediaFormat.enum';

type ProductNotificationStylesProps = {
  mediaFormat?: MediaFormatEnum;
};

const SNACKBAR_PADDING_BLOCK = 1.5;

export const useProductNotificationStyles = makeStyles<ProductNotificationStylesProps>()(
  (theme) => {
    const surface = {
      borderRadius: 16,
      border: `1px solid ${theme.palette.custom.border.primary}`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[16],
      display: 'flex',
      padding: theme.spacing(0, 2),
    };

    return {
      colorButton: {
        [theme.breakpoints.down('lg')]: { display: 'flex' },
      },
      cursor: {
        fontSize: '12px',
        cursor: 'pointer',
      },
      snackbar: {
        ...surface,
        width: 363,
        paddingBlock: theme.spacing(SNACKBAR_PADDING_BLOCK),
      },
      productAlreadySnackbar: {
        ...surface,
        width: 380,
        height: 60,
      },
    };
  },
);
